import { render, staticRenderFns } from "./six_basic_info.vue?vue&type=template&id=69575a26&scoped=true"
import script from "./six_basic_info.vue?vue&type=script&lang=js"
export * from "./six_basic_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69575a26",
  null
  
)

export default component.exports